


































































































































































































































































































































































































































































































































import SimpleMap from '../../core/components/SimpleMap.vue';
import InfoIcon from '../../core/components/InfoIcon.vue';
import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getDateFromTimestamp,
    getIdsFromList,
    removeItemsFromList,
    matchedIndexIdInArray,
    getUniqueId,
    formatDate,
    downloadFile,
    openTravelWithParameter,
    getAlertColorByPriority,
    timestampToTime,
    parseFloatNumber,
    copyTextToClipboard,
    goToUrl
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import DatePickerSingle from '../../core/components/DatePickerSingle.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import Input from '../../core/components/Input.vue';
import ModalNotes from './ModalNotes.vue';
import ModalVehicleHomologation from './ModalVehicleHomologation.vue';
import AnalyticView from './AnalyticView.vue';
import ModalUploadCSV from './ModalUploadCSV.vue';
import Button from '../../core/components/Button.vue';
import ModalViewAllCard from './ModalViewAllCard.vue';
import CalibrationPeriods from './CalibrationPeriods.vue';
import { booleanFormatter, getOnlyDateFromTimestamp, nullFormatter } from '../../core/utils/table-formatters';
import DeleteConfirmation from '../../tracking/components/Geofences/DeleteConfirmation.vue';
import {
    MsgBox,
    Combobox,
    LoadingDialog,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import { InsuranceServices } from '../api/InsuranceServices';
import Loading from 'vue-loading-overlay';
import ModalVehicleCalibration from './ModalVehicleCalibration.vue';
import CardVehicleSettings from './CardVehicleSettings.vue';
import CardLevMapa from './CardLevMapa.vue';
import CardVehicleCalibrations from './CardVehicleCalibrations.vue';
import { config } from 'rxjs';
import moment from 'moment';
import { getUrlFarmingDetail, getVariablesConfigurationsSorted } from '../utils';
import { farmingTypeOptions, getFactorTooltip, getTooltipForCalibrationPeriods } from '../helpers';

@Component({
    components: {
        Loading,
        Combobox,
        SimpleMap,
        DatePickerSingle,
        Button,
        SimpleTable,
        ModalNotes,
        AnalyticView,
        ModalUploadCSV,
        DeleteConfirmation,
        ModalVehicleHomologation,
        ModalVehicleCalibration,
        ModalViewAllCard,
        CardVehicleSettings,
        CardLevMapa,
        CalibrationPeriods,
        CardVehicleCalibrations,
        Input,
        InfoIcon
    }
})
export default class MachineDetail extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop() visible: boolean;
    @Prop() modifyData: object;
    @Prop() action: string;
    deleteType: string = '';
    firstTab: string = 'operational_view';
    panel: number = 0;
    calibrationPeriods: Array<object> = [];
    currentVehicle: Array<object> = [];
    companiesList: Array<object> = [];
    patchData: object = {};
    patchCalibration: any = null;
    visibleModalViewAll: boolean = false;
    viewAllType: string = '';
    headersCompanies: Array<object> = [
        {
            text: 'Nombre',
            align: 'left',
            value: 'name'
        }
    ];
    farmingList: Array<object> = [];
    itemsSettings: Array<object> = [];
    headersFarmings: Array<object> = [
        {
            text: 'Nombre',
            align: 'left',
            value: 'name'
        },
        {
            text: 'Empresa',
            align: 'left',
            value: 'company.name',
            width: '180px'
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions',
            width: '100px'
        }
    ];
    itemsNotes: Array<object> = [];
    headersNotes: Array<object> = [
        {
            text: 'Fecha',
            align: 'left',
            value: 'date_created',
            formatter: getOnlyDateFromTimestamp
        },
        {
            text: 'Nota',
            align: 'left',
            value: 'text'
        },
        {
            text: 'Usuario',
            align: 'center',
            value: 'created_by.username'
        },
        {
            text: 'Tipo',
            align: 'center',
            value: 'note_type',
            formatter: this.noteTypeFormatter
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions'
        }
    ];
    itemsAreaByDay: Array<object> = [];
    headersAreaByDay: Array<object> = [
        {
            text: 'Fecha',
            align: 'left',
            value: 'date',
            formatter: formatDate,
            width: '200px'
        },
        {
            text: 'Area',
            align: 'center',
            value: 'area'
        },
        {
            text: 'Factor de calibración (%)',
            align: 'center',
            value: 'performance_calibration_factor',
        },
        {
            text: 'Factor calibración humedad (%)',
            align: 'center',
            value: 'humidity_calibration_factor',
        }
    ];
    visibleModalNotes: boolean = false;
    visibleModalHomologation: boolean = false;
    visibleModalVehicleCalibration: boolean = false;
    ackValue: boolean = false;
    itemsHomologations: Array<object> = [];
    headersActiveAlerts: Array<object> = [
        // {
        //     text: 'Vehículo',
        //     align: 'left',
        //     value: 'vehicle_id',
        // },
        {
            text: 'Fecha Inicio',
            align: 'left',
            value: 'start',
            width: '200px',
            formatter: formatDate
        },
        {
            text: 'Fecha Fin',
            align: 'left',
            value: 'end',
            width: '200px',
            formatter: formatDate
        },
        {
            text: 'Eventos',
            align: 'left',
            value: 'events'
        },
        {
            text: 'Prioridad',
            align: 'center',
            value: 'priority',
            width: '100px'
        },
        {
            text: 'Ack',
            align: 'left',
            value: 'ack',
            width: '100px'
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions',
            width: '100px'
        }
    ];
    itemsActiveAlerts: Array<object> = [];
    itemsHistoricAlerts: Array<object> = [];
    vehiclesWithAlerts: number = 0;
    noteTypes: any = [];
    headersHistoricAlerts: Array<object> = [
        // {
        //     text: 'Vehículo',
        //     align: 'left',
        //     value: 'vehicle_id',
        // },
        {
            text: 'Fecha Inicio',
            align: 'left',
            value: 'start',
            width: '200px',
            formatter: formatDate
        },
        {
            text: 'Fecha Fin',
            align: 'left',
            value: 'end',
            width: '200px',
            formatter: formatDate
        },
        {
            text: 'Eventos',
            align: 'left',
            value: 'events'
        },
        {
            text: 'Prioridad',
            align: 'center',
            value: 'priority',
            width: '100px'
        },
        {
            text: 'Usuario ack',
            align: 'center',
            value: 'acknowledged_by.username',
            width: '150px'
        },
        {
            text: 'Fecha Ack',
            align: 'left',
            value: 'date_acknowledged',
            width: '200px',
            formatter: formatDate
        },
        {
            text: 'Acciones',
            align: 'center',
            value: 'actions',
            width: '100px'
        }
    ];
    loadingNotes: boolean = false;
    loadingSettings: boolean = false;
    loadingAlerts: boolean = false;
    loadingHomologations: boolean = false;
    loadingFarmings: boolean = false;
    loadingNextInspection: boolean = false;
    loadingCalibrations: boolean = false;
    loadingAreaByDay: boolean = false;
    loadingLevMap: boolean = false;
    noteItemToDelete: object = {};
    calibrationToDelete: object = {};
    configToDelete: object = {};
    levMapToDelete: object = {};
    homologationToDelete: object = {};
    vehicleVariables: Array<object> = [];
    patchHomologation: object | null = null;
    editingSetting: boolean = false;
    cropTypes: Array<object> = [];

    visibleModalFarming: boolean = false;
    editFarming: boolean = false;
    farmingPatchData: object = {};
    optionsInsuranceCompany: Array<object> = [];
    itemsInsuranceFarmings: Array<object> = [];
    dateSelected: any = null;
    currentFarming: string = '';
    visibleChart: boolean = true;
    forcedWorkSegments: any = [];

    itemsCalibrations: Array<object> = [];
    itemsLevMap: Array<object> = [];
    companys: Array<object> = [];
    companySelectedRV: boolean = false;
    companySelected: any = null;
    sortByAreaByDay: string[] = ['date'];
    sortDescAreaByDay: boolean[] = [false];

    //delete modal
    confirmationDelete: boolean = false;
    deleteModalTitle: string = '';
    deleteBody: string = '';


    getFactorColumnName(period: object, isPerformance: boolean, allPeriods: Array<object>){
        let factor = isPerformance ? period['performance_cal_factor'] : period['humidity_cal_factor'];

        if(factor == null || factor == undefined){
            return 'null'
        }
        return factor
    }

    getFactorInfo(period:object, isPerformance: boolean) {
        return getFactorTooltip(period, isPerformance)
    }


    refreshAnalyticView(){
        InsuranceServices.getVehicleSowingDetail(this.getVehicleID, this.patchData['farming_id'])
        .then(response => {
            this.setForcedWorkPeriods(response);
        })
        .catch(err => {
            
        });
    }


    @Emit()
    closeModal() {}

    @Emit()
    updateAlertInVehicle() {}

    @Emit()
    reloadMachineDetail(vehicleId, farmingId) {}

    @Watch('$_getInsuranceProperties')
    observableProperties() {
        this.assignPropertiesData();
    }

    parseCoordinates(value) {
        if (value && value['latitude'] && value['longitude']) {
            return value['latitude'] + ' ; ' + value['longitude'];
        } else {
            return '-';
        }
    }

    cropTypeFormatter(cropTypeId) {
        let allCropTypes = this.$_getInsuranceProperties['harvest_type'];
        if (allCropTypes) {
            let cropTypeIndex = allCropTypes.findIndex(item => Number(item['id']) === cropTypeId);
            if (cropTypeIndex !== -1) {
                return allCropTypes[cropTypeIndex]['value'];
            }
        }
    }

    noteTypeFormatter(noteTypeId) {
        let noteTypes = this.$_getInsuranceProperties['note_types'];
        if (noteTypes) {
            let noteTypeIndex = noteTypes.findIndex(item => Number(item['id']) === noteTypeId);
            if (noteTypeIndex !== -1) {
                return noteTypes[noteTypeIndex]['value'];
            }
        }
    }

    sensorStateFormatter(sensorId) {
        let sensorTypes = this.$_getInsuranceProperties['sensor_states'];
        if (sensorTypes) {
            let sensorTypeIndex = sensorTypes.findIndex(item => Number(item['id']) === sensorId);
            if (sensorTypeIndex !== -1) {
                return sensorTypes[sensorTypeIndex]['value'];
            }
        }
    }

    mounted() {
        this.assignPropertiesData();
        this.loadPatchData();
        this.getVehicleVariables();
    }

    setCurrentFarming(farmingId: number) {
        let indexFarming = matchedIndexIdInArray(this.farmingList, farmingId);
        if (indexFarming > -1) {
            this.currentFarming = this.farmingList[indexFarming]['name'];
        }
    }

    assignPropertiesData() {
        this.cropTypes = this.$_getInsuranceProperties['harvest_type'];
        this.noteTypes = this.$_getInsuranceProperties['note_types'];
        this.optionsInsuranceCompany = this.$_getInsuranceProperties['insurance_companies'];
        this.itemsInsuranceFarmings = this.$_getInsuranceProperties['insurance_farmings'];
    }

    getVehicleVariables() {
        this.vehicleVariables = [];
        if (this.getVehicleID) {
            InsuranceServices.getVehiclesVariables(this.getVehicleID)
                .then(res => {
                    this.vehicleVariables = getVariablesConfigurationsSorted(res['variable_configurations']);
                })
                .catch(err => {
                    this.vehicleVariables = [];
                });
        }
    }

    updateCompanySelected(value) {
        this.companySelected = value;
    }
    updateCompanySelectedRV(value) {
        this.companySelectedRV = value;
    }

    parseCalibrationFactor(value) {
        return parseFloatNumber(value, 1);
    }

    get isCarrier(): boolean {
        return this.$_getPrivileges[PRIVILEGE_KEYS.INSURANCE_CARRIER];
    }

    get getAlertColor() {
        return getAlertColorByPriority();
    }

    get cardVehCalibrations(): HTMLFormElement {
        return this.$refs.cardVehicleCalibration as HTMLFormElement;
    }

    get cardVehSetting(): HTMLFormElement {
        return this.$refs.cardVehicleSetting as HTMLFormElement;
    }

    get modalViewAll(): HTMLFormElement {
        return this.$refs.modalViewAll as HTMLFormElement;
    }

    get isSowing() {
        return this.action === 'sowing' ? true : false;
    }

    get getHarvestList() {
        if (this.patchData !== null) {
            return this.patchData['harvests'];
        } else {
            return [];
        }
    }

    get shouldDisplayAnalyticView(): boolean {
        return this.$_getPrivileges[PRIVILEGE_KEYS.INSURANCE_ANALYTICAL];
    }

    get getHeadersHomologations() {
        let headers = [
            {
                text: 'Fecha',
                align: 'left',
                value: 'date',
                formatter: getOnlyDateFromTimestamp
            },
            {
                text: 'Coordenadas',
                align: 'left',
                value: 'location',
                formatter: this.parseCoordinates
            },
            {
                text: 'Tipo de Cultivo',
                align: 'center',
                value: 'harvest_type',
                formatter: this.cropTypeFormatter
            },
            {
                text: 'Ancho Trabajo',
                align: 'center',
                value: 'work_width'
            },
            {
                text: 'Equipo Instalado (VIN)',
                align: 'center',
                value: 'current_vin'
            },
            {
                text: 'Responsable',
                align: 'center',
                value: 'user_email'
            },
            {
                text: 'Notas',
                align: 'center',
                value: 'notes'
            }
        ];
        if (!this.isSowing) {
            headers.push(
                {
                    text: 'Estado sensor flujo',
                    align: 'center',
                    value: 'flow_sensor_state',
                    formatter: this.sensorStateFormatter
                },
                {
                    text: 'Estado sensor humedad',
                    align: 'center',
                    value: 'humidity_sensor_state',
                    formatter: this.sensorStateFormatter
                }
            );
        }

        headers.push({
            text: 'Acciones',
            align: 'center',
            value: 'actions'
        });

        return headers;
    }


    

    loadPatchData() {
        // console.log('detalle sembradora', this.patchData);
        this.patchData = this.modifyData;
        this.currentVehicle =  [this.patchData['vehicle']];
        this.calibrationPeriods = this.patchData['vehicle_timeline'];
        this.companiesList = this.patchData['companies'];
        this.farmingList = this.patchData['farmings'];
        this.setCompanySelected();
        this.setConfigurations();
        this.setNotesList();
        this.setCalibrations(this.patchData);
        this.setLevMap(this.patchData);
        this.itemsHomologations = this.patchData['homologations'];
        this.itemsHistoricAlerts = this.patchData['alerts']['historical'];
        this.itemsActiveAlerts =
            this.patchData['alerts'] && this.patchData['alerts']['active'] !== null
                ? [this.patchData['alerts']['active']]
                : [];
        this.updateSelectedDate(this.patchData['next_visit']);
        this.setCurrentFarming(this.patchData['farming_id']);

        this.setForcedWorkPeriods(this.patchData);

        if (this.patchData['vehicle_area_by_day']) {
            this.loadingAreaByDay = true;
            this.setItemsAreaByDay(this.patchData['vehicle_area_by_day']);
        }
        for (let index = 0; index < this.itemsActiveAlerts.length; index++) {
            const item = this.itemsActiveAlerts[index];
            this.$set(item, 'id', getUniqueId());
        }
        this.vehiclesWithAlerts = this.getVehiclesWithAlerts();
    }

    setForcedWorkPeriods(res) {
        let items:Array<object> = [];
        let self = this;
        if (res['forced_work_lapses']) {
            items = res['forced_work_lapses'];
            if(items.length > 0){
                items = items.map(function(item){
                    return {
                        ...item,
                        vehicle: self.currentVehicle
                    }
                })
            }
        }
        this.forcedWorkSegments = items;
    }

    setConfigurations() {
        this.itemsSettings = this.patchData['configurations']
    }

    setCompanySelected() {
        let harvestCompanyId = this.patchData['farmings'][0]['company_id'];
        let indexCompany = matchedIndexIdInArray(this.companiesList, harvestCompanyId);
        if (indexCompany !== -1) {
            this.updateCompanySelected(this.companiesList[indexCompany]);
        }
    }

    setNotesList() {
        this.itemsNotes = this.patchData['notes'];
        for (let index = 0; index < this.itemsNotes.length; index++) {
            const note = this.itemsNotes[index];
            if (note['created_by']['username'] !== this.$_getUserName) {
                this.$set(note, 'disableDelete', true);
            }
        }
    }

    setCalibrations(patchData) {
        this.loadingCalibrations = true;
        if (!this.isSowing) {
            this.itemsCalibrations = patchData['calibrations'];
        }
        this.loadingCalibrations = false;
    }

    setLevMap(patchData) {
        this.loadingLevMap = true;
        if (!this.isSowing) {
            this.assignLevMapItems(patchData['performance_map_csv']);
        }
        this.loadingLevMap = false;
    }

    setLevMapItems(items) {
        this.itemsLevMap = items;
    }

    assignLevMapItems(items) {
        for (let index = 0; index < items.length; index++) {
            const item = items[index];
            let companyName = item['harvest']['company']['name'];
            let harvestName = companyName + ' - ' + item['harvest']['name'];
            this.$set(item['harvest'], 'name', harvestName);
        }
        this.setLevMapItems(items);
    }

    updateCalibrationPeriodsAndAreaByDay() {
        // console.log('reload machine detail');
        if (this.patchData !== null) {
            this.reloadMachineDetail(this.getVehicleID, this.patchData['farming_id']);
        }
    }

    setItemsAreaByDay(items) {
        this.itemsAreaByDay = items;
        this.loadingAreaByDay = false;
    }

    //Return vehicle data
    get getVehicleDescription() {
        return this.patchData['vehicle'] && this.patchData['vehicle']['description']
            ? this.patchData['vehicle']['description']
            : ' - ';
    }
    get getVehicleVin() {
        return this.patchData['vehicle'] && this.patchData['vehicle']['vin'] ? this.patchData['vehicle']['vin'] : ' - ';
    }
    get getVehicleID() {
        return this.patchData['vehicle'] && this.patchData['vehicle']['id'] ? this.patchData['vehicle']['id'] : null;
    }
    get getVehicleState() {
        return this.patchData['vehicle'] && this.patchData['vehicle']['state']
            ? this.patchData['vehicle']['state']
            : ' - ';
    }
    get getSowingName() {
        if (this.getVehicleDescription !== ' - ') {
            return this.getVehicleDescription;
        } else {
            return this.getVehicleVin;
        }
    }
    get vehicleHasVariableConfiguration() {
        return this.vehicleVariables.length > 0 ? true : false;
    }
    get existNextVisitDate() {
        return this.patchData['next_visit'] !== null ? true : false;
    }
    getVehiclesWithAlerts() {
        let vehicleIds: any = this.itemsHistoricAlerts.map(s => s['vehicle_id']);
        if (vehicleIds.length !== 0) {
            let vehicles = this.removeDuplicatedFromObject(vehicleIds);
            return vehicles.length;
        } else {
            return 0;
        }
    }

    removeDuplicatedFromObject(object) {
        let uniqueObject = object.filter(function(item, pos) {
            return object.indexOf(item) == pos;
        });

        return uniqueObject;
    }

    dateFormatter(value) {
        let date = moment(value);
        if (!date.isValid()) {
            return '-';
        } else {
            return getDateFromTimestamp(value);
        }
    }

    filterByCompany(item) {
        return this.companySelected == null ? true : item === this.companySelected['name'];
    }

    visibilityModalNotes(value) {
        this.visibleModalNotes = value;
    }

    visibilityModalHomologation(value) {
        this.visibleModalHomologation = value;
    }
    visibilityModalCalibration(value) {
        this.visibleModalVehicleCalibration = value;
        if (!value) {
            this.patchCalibration = {};
        }
    }

    addNewNote(newNote) {
        this.loadingNotes = true;
        let oldItems = this.itemsNotes;
        this.itemsNotes = [];
        oldItems.push(newNote);

        setTimeout(() => {
            this.itemsNotes = oldItems;
            this.loadingNotes = false;
            this.reloadPreviousList();
        }, 1000);
    }

    ackAlerts(item) {
        this.loadingAlerts = true;
        let data = {
            vehicle_id: item['vehicle_id'],
            alert_type: 1
        };
        InsuranceServices.postAlertAcknowledge(data)
            .then(res => {
                this.loadingAlerts = false;
                this.$_successDeleteRecipients(res['message']);
                this.$set(item, 'acknowledged', true);
                this.addAlertToHistoricList(res['new_alert_acknowledge'], item['id']);
                this.reloadPreviousList();
            })
            .catch(res => {
                this.$set(item, 'acknowledged', false);
                this.loadingAlerts = false;
            });
    }

    ackHomologations(item) {
        this.loadingHomologations = true;

        if (this.isSowing) {
            InsuranceServices.sowingHomologationAcknowledge(item['id'])
                .then(response => {
                    let msg = '';
                    if (response && response.data && response.data.message) {
                        msg = response.data.message;
                    } else {
                        msg = '';
                    }
                    this.loadingHomologations = false;
                    this.$_successDeleteRecipients(msg);
                    this.reloadPreviousList();
                })
                .catch(res => {
                    this.loadingHomologations = false;
                });
        } else {
            InsuranceServices.harvestHomologationAcknowledge(item['id'])
                .then(response => {
                    let msg = '';
                    if (response && response.data && response.data.message) {
                        msg = response.data.message;
                    } else {
                        msg = '';
                    }
                    this.loadingHomologations = false;
                    this.$_successDeleteRecipients(msg);
                    this.reloadPreviousList();
                })
                .catch(res => {
                    this.loadingHomologations = false;
                });
        }
    }

    ackDateAction() {
        let self = this;
        InsuranceServices.patchNextVisitAcknowledge(this.getVehicleID)
            .then(response => {
                let msg = '';
                if (response && response.data && response.data.message) {
                    msg = response.data.message;
                } else {
                    msg = 'La proxima visita ha sido marcada como completada';
                }
                self.updateSelectedDate(null);
                self.updateNextVisitDate(null);
                this.reloadPreviousList();
                this.$_successDeleteRecipients(msg);
            })
            .catch(err => {});
    }

    updateNextVisitDate(value) {
        this.$set(this.patchData, 'next_visit', value);

        if (value == null) {
            this.ackValue = false;
        }
    }

    addAlertToHistoricList(newAlertAcknowledge, idActiveAlert) {
        let self = this;
        let indexActiveAlertToRemove = matchedIndexIdInArray(self.itemsActiveAlerts, idActiveAlert);
        if (indexActiveAlertToRemove !== -1) {
            let historicAlert = {
                vehicle_id: self.itemsActiveAlerts[indexActiveAlertToRemove]['vehicle_id'],
                start: self.itemsActiveAlerts[indexActiveAlertToRemove]['start'],
                end: self.itemsActiveAlerts[indexActiveAlertToRemove]['end'],
                events: self.itemsActiveAlerts[indexActiveAlertToRemove]['events'],
                priority: self.itemsActiveAlerts[indexActiveAlertToRemove]['priority'],
                acknowledged_by: newAlertAcknowledge['user'],
                date_acknowledged: newAlertAcknowledge['date'],
                id: getUniqueId()
            };
            self.itemsHistoricAlerts.push(historicAlert);
            self.itemsActiveAlerts.splice(indexActiveAlertToRemove, 1);
            self.reloadPreviousList();
        }
    }

    patchCalibrationFactor(item) {
        // console.log('patch calibration factor', item);
        this.$set(item, 'isLoading', true);
        let data = {
            calibration_factor: null,
            humidity_calibration_factor: null
        };
        InsuranceServices.patchVehicleAreaByDay(data, item['id'])
            .then(res => {
                this.$set(item, 'isLoading', false);
                this.$set(item, 'remove', false);
                this.$set(item, 'calibration_factor', null);
                this.$set(item, 'humidity_calibration_factor', null);
                this.$_successDeleteRecipients(res['data']['message']);
            })
            .catch(error => {
                this.$set(item, 'isLoading', false);
                let msg =
                    error && error.response && error.response.data && error.response.data.message
                        ? error.response.data.message
                        : 'No se pudo quitar el factor de descalibración';
                this.$_successDeleteRecipients(msg);
            });
    }

    updateHomologation(updatedHomologation) {
        this.loadingHomologations = true;
        let indexIdToPatch = matchedIndexIdInArray(this.itemsHomologations, updatedHomologation['id']);
        if (indexIdToPatch !== -1) {
            this.$set(this.itemsHomologations[indexIdToPatch], 'acknowledged', updatedHomologation['acknowledged']);
            this.$set(
                this.itemsHomologations[indexIdToPatch],
                'date_acknowledged',
                updatedHomologation['date_acknowledged']
            );
            this.$set(this.itemsHomologations[indexIdToPatch], 'date', updatedHomologation['date']);
            this.$set(this.itemsHomologations[indexIdToPatch], 'user_email', updatedHomologation['user_email']);
            this.$set(this.itemsHomologations[indexIdToPatch], 'harvest_type', updatedHomologation['harvest_type']);
            this.$set(this.itemsHomologations[indexIdToPatch], 'location', updatedHomologation['location']);
            this.$set(this.itemsHomologations[indexIdToPatch], 'notes', updatedHomologation['notes']);
            this.$set(this.itemsHomologations[indexIdToPatch], 'work_width', updatedHomologation['work_width']);
            this.$set(
                this.itemsHomologations[indexIdToPatch],
                'independent_sections',
                updatedHomologation['independent_sections']
            );
            this.$set(this.itemsHomologations[indexIdToPatch], 'current_vin', updatedHomologation['current_vin']);

            if (!this.isSowing) {
                this.$set(this.itemsHomologations[indexIdToPatch], 'monitor_type', updatedHomologation['monitor_type']);
                this.$set(
                    this.itemsHomologations[indexIdToPatch],
                    'flow_sensor_state',
                    updatedHomologation['flow_sensor_state']
                );
                this.$set(
                    this.itemsHomologations[indexIdToPatch],
                    'humidity_sensor_state',
                    updatedHomologation['humidity_sensor_state']
                );
            }
        }
        this.reloadViewAllModalDetail();
        this.loadingHomologations = false;
    }

    visibilityModalViewAll(value) {
        this.visibleModalViewAll = value;
    }

    reloadViewAllModalDetail() {
        if (this.visibleModalViewAll) {
            this.modalViewAll.getData();
        }
    }

    reloadPreviousList() {
        if (this.isSowing) {
            this.$emit('reload-sowing-list');
        } else {
            this.$emit('reload-harvest-list');
        }
    }

    deleteNoteAction(noteToDelete) {
        this.noteItemToDelete = noteToDelete;
        this.setDeleteType('note');
        this.showDeleteConfirmationDialog(
            'Eliminar Nota',
            '¿Está seguro que desea eliminar la nota <b>' + this.noteItemToDelete['text'] + '</b> ?'
        );
    }

    deleteCalibration(calibrationToDelete) {
        this.calibrationToDelete = calibrationToDelete;
        this.setDeleteType('calibration');
        this.showDeleteConfirmationDialog('Eliminar Calibración', '¿Está seguro que desea eliminar esta calibración?');
    }

    deleteConfiguration(configToDelete) {
        this.cardVehSetting.deleteConfiguration(configToDelete);
    }

    editSetting(settingToEdit) {
        this.cardVehSetting.editSetting(settingToEdit);
    }

    deleteLevMap(levMapToDelete) {
        this.levMapToDelete = levMapToDelete;
        this.setDeleteType('levmap');
        this.showDeleteConfirmationDialog('Eliminar Levantada de Mapa', '¿Está seguro que desea eliminar este CSV?');
    }

    deleteHomologation(homToDelete) {
        this.homologationToDelete = homToDelete;
        this.setDeleteType('homologation');
        let homType = this.isSowing ? 'Homologación de Siembra' : 'Homologación de Cosecha';
        this.showDeleteConfirmationDialog(homType, '¿Está seguro que desea eliminar esta homologación?');
    }

    setDeleteType(value) {
        this.deleteType = value;
    }

    showDeleteConfirmationDialog(title, msgBody) {
        this.deleteModalTitle = title;
        this.deleteBody = msgBody;
        this.confirmationDelete = true;
    }

    deleteAction(value) {
        if (value) {
            this.confirmationDelete = false;
            if (this.deleteType === 'note') {
                this.deleteNote();
            } else if (this.deleteType === 'calibration') {
                this.removeCalibration();
            } else if (this.deleteType === 'levmap') {
                this.removeLevMap();
            } else if (this.deleteType === 'homologation') {
                if (this.isSowing) {
                    this.deleteSowingHomologation();
                } else {
                    this.deleteHarvestHomologation();
                }
            }
        } else {
            this.confirmationDelete = false;
        }
        this.setDeleteType('');
    }

    removeLevMap() {
        let self = this;
        this.loadingLevMap = true;
        InsuranceServices.deleteLevMap(this.levMapToDelete['id'])
            .then(response => {
                let msg = '';
                if (response && response.data && response.data.message) {
                    msg = response.data.message;
                } else {
                    msg = 'CSV eliminado con exito';
                }
                self.$_successDeleteRecipients(msg);
                self.assignLevMapItems(removeItemsFromList(self.itemsLevMap, [self.levMapToDelete], 'id'));
                self.loadingLevMap = false;
                self.reloadPreviousList();
                self.reloadViewAllModalDetail();
            })
            .catch(error => {
                this.showMsgError(error);
                self.loadingLevMap = false;
            });
    }

    deleteSowingHomologation() {
        let self = this;
        this.loadingHomologations = true;
        InsuranceServices.deleteSowingHomologation(this.homologationToDelete['id'])
            .then(response => {
                let msg = '';
                if (response && response.data && response.data.message) {
                    msg = response.data.message;
                } else {
                    msg = 'Homologación Eliminada con éxito';
                }
                self.$_successDeleteRecipients(msg);
                self.itemsHomologations = removeItemsFromList(
                    self.itemsHomologations,
                    [self.homologationToDelete],
                    'id'
                );
                self.loadingHomologations = false;
                self.reloadPreviousList();
                self.reloadViewAllModalDetail();
            })
            .catch(error => {
                this.showMsgError(error);
                self.loadingHomologations = false;
            });
    }

    deleteHarvestHomologation() {
        let self = this;
        this.loadingHomologations = true;
        InsuranceServices.deleteHarvestHomologation(this.homologationToDelete['id'])
            .then(response => {
                let msg = '';
                if (response && response.data && response.data.message) {
                    msg = response.data.message;
                } else {
                    msg = 'Homologación Eliminada con éxito';
                }
                self.$_successDeleteRecipients(msg);
                self.itemsHomologations = removeItemsFromList(
                    self.itemsHomologations,
                    [self.homologationToDelete],
                    'id'
                );
                self.loadingHomologations = false;
                self.reloadViewAllModalDetail();
                self.reloadPreviousList();
            })
            .catch(error => {
                this.showMsgError(error);
                self.loadingHomologations = false;
            });
    }

    removeCalibration() {
        let self = this;
        this.loadingCalibrations = true;
        InsuranceServices.deleteCalibration(this.calibrationToDelete['id'])
            .then(response => {
                let msg = '';
                if (response && response.data && response.data.message) {
                    msg = response.data.message;
                } else {
                    msg = 'Calibración Eliminada con éxito';
                }
                self.reloadPreviousList();
                self.$_successDeleteRecipients(msg);
                self.itemsCalibrations = removeItemsFromList(self.itemsCalibrations, [self.calibrationToDelete], 'id');
                self.loadingCalibrations = false;
                self.reloadViewAllModalDetail();
            })
            .catch(error => {
                this.showMsgError(error);
                self.loadingCalibrations = false;
            });
    }

    showMsgError(error) {
        let self = this;
        let msg = '';
        if (error && error.response && error.response.data && error.response.data.message) {
            msg = error.response.data.message;
        } else {
            msg = 'Ocurrió un error';
        }
        this.$_errorAddFilter(msg);
    }

    deleteNote() {
        let self = this;
        this.loadingNotes = true;
        InsuranceServices.deleteVehicleNote(this.noteItemToDelete['id'])
            .then(response => {
                let msg = '';
                if (response && response.message) {
                    msg = response.message;
                } else {
                    msg = 'Nota Eliminada con éxito';
                }
                self.$_successDeleteRecipients(msg);
                self.itemsNotes = removeItemsFromList(self.itemsNotes, [self.noteItemToDelete], 'id');
                self.loadingNotes = false;
                self.reloadViewAllModalDetail();
            })
            .catch(err => {
                this.showMsgError(err);
                self.loadingNotes = false;
            });
    }

    variableFormatter(item) {
        // console.log("variableFormatter", item);
        if (item !== null) {
            let varDescription = item['description'] !== null ? item['description'] : '';
            return item['variable_id'] + ' - ' + varDescription;
        } else {
            return '-';
        }
    }

    downloadLevMap(item) {
        this.$set(item, 'isDownloading', true);
        let csvUrl = item['url'];
        InsuranceServices.getArrayBufferFromUrl(csvUrl)
            .then(res => {
                this.$set(item, 'isDownloading', false);
                let actualHour = moment().format('DD-MM-YYYY_HH:mm');
                let company =
                    item['harvest'] && item['harvest']['company'] && item['harvest']['company']['name']
                        ? item['harvest']['company']['name']
                        : null;
                if (company == null) {
                    company = item['harvest']['name'];
                } else {
                    company += '_' + item['harvest']['name'];
                }
                let fileName = company + '_' + 'performance_map' + '_' + actualHour + '.csv';
                downloadFile(fileName, res);
            })
            .catch(err => {
                this.$set(item, 'isDownloading', false);
            });
    }

    clickAddNewHomologation() {
        this.patchHomologation = null;
        this.visibilityModalHomologation(true);
    }

    editHomologation(item) {
        this.patchHomologation = item;
        this.visibilityModalHomologation(true);
    }

    addNewHomologation(newHomologation) {
        this.loadingHomologations = true;
        let oldItems = this.itemsHomologations;
        this.itemsHomologations = [];
        oldItems.push(newHomologation);

        setTimeout(() => {
            this.itemsHomologations = oldItems;
            this.loadingHomologations = false;
        }, 1000);
    }

    createNewCalibration() {
        this.patchCalibration = null;
        this.visibilityModalCalibration(true);
    }

    modifyCalibration(item) {
        this.cardVehCalibrations.modifyCalibration(item);
    }

    modifyFarming(item) {
        goToUrl(getUrlFarmingDetail(item['id']))
    }

    updateFarming(newFarming) {
        this.loadingFarmings = true;
        let indexFarmingToEdit = matchedIndexIdInArray(this.farmingList, this.farmingPatchData['id']);
        if (indexFarmingToEdit !== -1) {
            this.$set(this.farmingList[indexFarmingToEdit], 'name', newFarming['name']);
        }
        this.loadingFarmings = false;
    }

    visibilityModalFarming(value) {
        this.visibleModalFarming = value;
    }

    updateSelectedDate(value) {
        this.dateSelected = value;
    }

    clickNextInspection() {
        this.loadingNextInspection = true;
        this.modifyNextInspectionDate();
    }

    get getInspectionDateValue() {
        return {
            vehicle: this.getVehicleID,
            date:
                this.dateSelected.indexOf('T') > -1
                    ? this.dateSelected
                    : moment(this.dateSelected, 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss')
        };
    }

    modifyNextInspectionDate() {
        InsuranceServices.postVehiclesNextVisit(this.getInspectionDateValue)
            .then(res => {
                this.$_successDeleteRecipients(res['message']);
                this.updateNextVisitDate(this.dateSelected);
                this.loadingNextInspection = false;
            })
            .catch(error => {
                this.loadingNextInspection = false;
                if (error && error.response && error.response.status !== 200) {
                    this.$_showHistoricalError(
                        'No se pudo modificar la fecha de próxima inspección. Intente nuevamente'
                    );
                }
            });
    }

    get getCompanyIdForTravelParameter() {
        return this.companiesList && this.companiesList.length ? this.companiesList[0]['id'] : -1;
    }

    viewAlertInMap(item) {
        openTravelWithParameter(item['start'], item['end'], [item['vehicle_id']], this.companiesList[0]['id']);
    }

    viewAllCalibrations() {
        this.viewAllType = 'calibrations';
        this.visibilityModalViewAll(true);
    }

    viewAllConfigurations() {
        this.viewAllType = 'settings';
        this.visibilityModalViewAll(true);
    }

    viewAllNotes() {
        this.viewAllType = 'notes';
        this.visibilityModalViewAll(true);
    }

    viewAllLevMap() {
        this.viewAllType = 'levmap';
        this.visibilityModalViewAll(true);
    }

    viewAllHomologations() {
        if (this.isSowing) {
            this.viewAllType = 'sowhomologations';
        } else {
            this.viewAllType = 'harhomologations';
        }

        this.visibilityModalViewAll(true);
    }

    parseNumber(value) {
        return parseFloatNumber(value);
    }
}
